import { render, staticRenderFns } from "./product-list.vue?vue&type=template&id=b0763ab8&scoped=true"
import script from "./product-list.vue?vue&type=script&lang=js"
export * from "./product-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0763ab8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0763ab8')) {
      api.createRecord('b0763ab8', component.options)
    } else {
      api.reload('b0763ab8', component.options)
    }
    module.hot.accept("./product-list.vue?vue&type=template&id=b0763ab8&scoped=true", function () {
      api.rerender('b0763ab8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/rebate/channel-cost-config/form/product-list.vue"
export default component.exports